import { NewsType } from '@/pages/News/types';

export const getNewsTypeName = (newsType?: NewsType) => {
  switch (newsType) {
    case NewsType.News: {
      return 'お知らせ';
    }
    case NewsType.Campaign: {
      return 'キャンペーン';
    }
    case NewsType.Blog: {
      return 'ブログ';
    }
    default: {
      throw new Error('未定義');
    }
  }
};
